// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-content-text{
    min-height: 300px;
    display: flex;
    width: 100%;
    height: 100%;
    align-content: center;
    align-items: center;
    justify-content: center;
    margin-bottom: 200px;
}`, "",{"version":3,"sources":["webpack://./src/components/NoContent/NoContent.scss"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB","sourcesContent":[".no-content-text{\n    min-height: 300px;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-content: center;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 200px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
